<template>
  <aside class="ea-sidebar">
    <!-- TOP STRENGTHS -->
    <div class="ea-side-card">
      <div class="ea-side-card__header">
        <span>Top Strengths</span>
        <button class="ea-hide-btn" @click="toggleStrengths">
          {{ showStrengths ? 'Hide' : 'Show' }}
        </button>
      </div>
      <ul v-show="showStrengths" class="ea-side-list">
        <li v-for="(item, i) in topStrengths" :key="'strength-' + i">
          <span class="ea-dot" :style="{ background: item.color }"></span>
          {{ item.label }}
        </li>
      </ul>
    </div>

    <!-- KEY AREAS FOR DEVELOPMENT -->
    <div class="ea-side-card">
      <div class="ea-side-card__header">
        <span>Key Areas for Development</span>
        <button class="ea-hide-btn" @click="toggleDevAreas">
          {{ showDevAreas ? 'Hide' : 'Show' }}
        </button>
      </div>
      <ul v-show="showDevAreas" class="ea-side-list">
        <li v-for="(item, i) in keyAreas" :key="'area-' + i">
          <span class="ea-dot" :style="{ background: item.color }"></span>
          {{ item.label }}
        </li>
      </ul>
    </div>

    <!-- EXECUTIVE INSIGHTS -->
    <div class="ea-side-card">
      <div class="ea-side-card__header">
        <span>Executive Insights</span>
        <button class="ea-hide-btn" @click="toggleInsights">
          {{ showInsights ? 'Hide' : 'Show' }}
        </button>
      </div>
      <div v-show="showInsights" class="ea-insight-box">
        <div class="ea-insight-title">
          <i class="fa-solid fa-chart-column"></i>
          STRATEGIC FINDINGS
        </div>
        <p class="ea-insight-text">{{ strategicFindings }}</p>
      </div>
    </div>
  </aside>
</template>

<script>
/**
 * Static / placeholder content only.
 * The API does not yet return this data — per ticket, this section
 * will be wired up to real endpoints in a future iteration.
 */
export default {
  name: "ExecutiveSidebar",
  data: () => ({
    showStrengths: true,
    showDevAreas: true,
    showInsights: true,
    topStrengths: [
      { label: "We Collaborate", color: "#2e7d32" },
      { label: "We Drive Engagement", color: "#123f75" },
      { label: "We Foster Growth Mindset", color: "#36618b" },
      { label: "We Deliver Results Efficiently", color: "#76a0cd" },
    ],
    keyAreas: [
      { label: "Coaching Presence", color: "#e67829" },
      { label: "Agile Decision Making", color: "#e67829" },
      { label: "Talent Pipeline", color: "#ba1a1a" },
    ],
    strategicFindings:
      "Strategic Planning remains the strongest competency globally. Coaching and Talent Development continue to represent the largest capability gaps, particularly within APAC and Director populations. Self-awareness remains strong overall, although Executive Committee members show the largest Self vs Others variance.",
  }),
  methods: {
    toggleStrengths() { this.showStrengths = !this.showStrengths; },
    toggleDevAreas() { this.showDevAreas = !this.showDevAreas; },
    toggleInsights() { this.showInsights = !this.showInsights; },
  },
};
</script>

<style scoped>
.ea-sidebar {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  width: 100%;
}

.ea-side-card {
  background: var(--card-bg);
  border: 1px solid var(--card-border);
  border-radius: var(--radius-lg);
  overflow: hidden;
}

.ea-side-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--space-xs) var(--space-sm);
  font-family: var(--font-family);
  font-size: var(--label-md-size);
  font-weight: var(--label-md-weight);
  letter-spacing: var(--label-md-tracking);
  text-transform: uppercase;
  color: var(--primary);
}

.ea-hide-btn {
  background: var(--surface-container-low);
  border: 1px solid var(--outline-variant);
  color: var(--on-surface-variant);
  border-radius: var(--radius);
  font-size: 11px;
  padding: 4px 10px;
  cursor: pointer;
  text-transform: none;
  letter-spacing: 0;
}
.ea-hide-btn:hover {
  background: var(--surface-container);
}

.ea-side-list {
  list-style: none;
  margin: 0;
  padding: 0 var(--space-sm) var(--space-sm);
}
.ea-side-list li {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 0;
  border-top: 1px solid var(--row-divider);
  font-family: var(--font-family);
  font-size: var(--body-md-size);
  color: var(--on-surface);
}
.ea-side-list li:first-child {
  border-top: none;
}

.ea-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ea-insight-box {
  margin: 0 var(--space-sm) var(--space-sm);
  background: #e9f7ee;
  border-radius: var(--radius-md);
  padding: var(--space-sm);
}
.ea-insight-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: var(--font-family);
  font-size: var(--label-md-size);
  font-weight: var(--label-md-weight);
  letter-spacing: var(--label-md-tracking);
  color: #1e7d3a;
  margin-bottom: 10px;
  text-transform: uppercase;
}
.ea-insight-text {
  font-family: var(--font-family);
  font-size: var(--body-md-size);
  line-height: var(--body-lg-line);
  color: var(--on-surface-variant);
  margin: 0;
}

@media only screen and (max-width: 1199px) {
  .ea-sidebar {
    flex-direction: row;
    flex-wrap: wrap;
  }
  .ea-side-card {
    flex: 1 1 260px;
  }
}

@media only screen and (max-width: 767px) {
  .ea-sidebar {
    flex-direction: column;
  }
}
</style>
